import HotelRestaurantMenuContent from './HotelRestaurantMenuContent.component';
export default HotelRestaurantMenuContent;